<script>
    import Button from '../reusableitems/DesktopButton.svelte';
    import LandingPagenavbar from '../reusableitems/landingPagenavbar.svelte';
    import OnPageLoad from '../reusableitems/onPageLoad.svelte';
    import rpcjs from 'rpcjs';
    const {title} = rpcjs.props;
    title.set('Advertisers');
    let flag = false;
    let image;
    let circle;
    const box = [];
</script>

<div class="navbar">
    <LandingPagenavbar textClrAfter='white' textclr='black' bgClrAfter='black'/>
</div>
<div>
    <OnPageLoad background='conic-gradient( white 0deg 90deg, #66FF00 90deg 270deg, white 270deg 360deg)'/>
</div>
<div class="main-div"> 
    <div
        role="presentation"
        class="left"
        on:click={() => {
            if (flag === true) {
                image.style.transform = 'scale(1)';
                flag = false;
                circle.style.opacity = '1';
                box[0].style.opacity = '0';
                box[1].style.opacity = '0';
                box[2].style.opacity = '0';
                box[3].style.opacity = '0';
                box[4].style.opacity = '0';
            }
        }}
    >
        <div class="text1">
            <p>A new paradigm for advertising</p>
        </div>

        <hr class="hrcss" />
        <p class="heading">
            Imagine dynamic placement of <span style="font-weight: 800;">3D+ <sup style="font-size: 1.852vh;font-weight:400;margin-left:-1vw;">*</sup></span> ads never seen before.
        </p>
        <p class="text2">
            We’re all familiar with the automated bidding process that the
            advent of digital media and more specifically, internet advertising
            brought. Like it or hate it, it significantly broadened the
            advertisement industry for all participants.
            <br />
            <br />
            <br />
            <b>
                We’re taking it to the next level by dynamically placing
                accessories, props and apparel of beloved characters. Coupling
                it with anonymous privacy respecting personalized product
                placement and the ad world will never be the same again.
            </b><br /><br />
            <br />
            That future is being build and you can be part of it by joining our advertiser
            governing council which grants you access to alpha testing, feature suggestions
            and one-to-one conversation with our team.
        </p>
        <div class="btn">
            <Button
            state = "Advertiser"
            text = 'Join Advertisement  Governance Council'
            TextColor2 = 'black'
            TextColor = 'black'
            TextSize = 0.625vw
            BackColor = 'transparrent'
            borderClr = '0.1vw solid black'
            TextColorAFter = '#54F862'
            />
        </div>
        <div class="text3">
            <p>* x/y/z + motion. We like to call it 3D+</p>
        </div>
    </div>

    <div class="right">
        <div class="img-class" bind:this={image}>
            <img
                role="presentation"
                src="images/consumerPage/advert.png"
                alt=""
                width="100%"
                height="100%"
                on:click={() => {
                    if (flag === true) {
                        image.style.transform = 'scale(1)';
                        flag = false;
                        circle.style.opacity = '1';
                        box[0].style.opacity = '0';
                        box[1].style.opacity = '0';
                        box[2].style.opacity = '0';
                        box[3].style.opacity = '0';
                        box[4].style.opacity = '0';
                    }
                }}
            />
        </div>
        <div bind:this={circle} style="transition-duration: 2s;" >
        <div
            role="presentation"
            class="circle"
            on:click={() => {
                if (flag === false) {
                    image.style.transform =
                        'scale(2.8) translate(12vw, 14.5vw)';
                    flag = true;
                    circle.style.opacity = '0';
                    box[0].style.opacity = '1';
                }
            }}
        />

        <div
        role="presentation"
            class="circle"
            style="top: 28.704vh;left: 55.444vh;"
            on:click={() => {
                if (flag === false) {
                    image.style.transform = 'scale(2.5) translate(-7vw, 9vw)';
                    flag = true;
                    circle.style.opacity = '0';
                    box[1].style.opacity = '1';
                }
            }}
        />

        <div
            role="presentation"
            class="circle"
            style="top: 50.833vh;left: 60vh;"
            on:click={() => {
                if (flag === false) {
                    image.style.transform = 'scale(2.5) translate(-8vw, 1.5vw)';
                    flag = true;
                    circle.style.opacity = '0';
                    box[2].style.opacity = '1';
                }
            }}
        />

        <div
            role="presentation"
            class="circle"
            style=" top: 62.407vh; left: 28.056vh;"
            on:click={() => {
                if (flag === false) {
                    image.style.transform = 'scale(2) translate(5.5vw, -8.5vw)';
                    flag = true;
                    circle.style.opacity = '0';
                    box[3].style.opacity = '1';
                }
            }}
        />

        <div
            class="circle"
            role="presentation"
            style="top: 80vh; left: 63.5vh;"
            on:click={() => {
                if (flag === false) {
                    image.style.transform ='scale(2) translate(-9.9vw, -11vw)';
                    flag = true;
                    circle.style.opacity = '0';
                    box[4].style.opacity = '1';
                }
            }}
        />
        </div>
        <div class="box1" bind:this={box[0]}>
            <div class="star">
                <img src="/images/star.svg" alt="" width="100%" height="100%" />
            </div>
            <div>
                <p
                    style="font-size: 1.852vh;
                padding-left: 0.833vh;
                font-weight: 700;
                padding-top: 2.778vh;"
                >
                    Advertise
                </p>

                <p
                    style="font-size: 1.111vh;
                padding-left: 0.8vh;
                paddig-top: 0.741vh ;"
                >
                    your product / brand
                </p>
            </div>
        </div>

        <div
            class="box1"
            style=" top: 50vh; left: 41.296vh;"
            bind:this={box[1]}
        >
            <div class="star">
                <img src="/images/star.svg" alt="" width="100%" height="100%" />
            </div>
            <div>
                <p
                    style="font-size: 1.852vh;
                padding-left: 0.833vh;
                font-weight: 700;
                padding-top: 2.778vh;"
                >
                    Advertise
                </p>

                <p
                    style="font-size: 1.111vh;
                padding-left: 0.8vh;
                paddig-top: 0.741vh;"
                >
                    your product / brand
                </p>
            </div>
        </div>

        <div
            class="box1"
            style="top: 64.537vh; left: 42.130vh;"
            bind:this={box[2]}
        >
            <div class="star">
                <img src="/images/star.svg" alt="" width="100%" height="100%" />
            </div>
            <div>
                <p
                    style="font-size: 1.852vh;
                padding-left: 0.833vh;
                font-weight: 700;
                padding-top: 2.778vh;"
                >
                    Advertise
                </p>

                <p
                    style="font-size: 1.111vh;
                padding-left: 0.8vh;
                paddig-top: 0.741vh"
                >
                    your product / brand
                </p>
            </div>
        </div>

        <div
            class="box1"
            style="top: 45.463vh; left: 41.296vh;"
            bind:this={box[3]}
        >
            <div class="star">
                <img src="/images/star.svg" alt="" width="100%" height="100%" />
            </div>
            <div>
                <p
                    style="font-size: 1.852vh;
                padding-left: 0.833vh;
                font-weight: 700;
                padding-top: 2.778vh ;"
                >
                    Advertise
                </p>

                <p
                    style="font-size: 1.111vh;
                padding-left: 0.8vh;
                paddig-top: 0.741vh"
                >
                    your product / brand
                </p>
            </div>
        </div>

        <div
            class="box1"
            style="top: 58.519vh; left: 44.259vh;"
            bind:this={box[4]}
        >
            <div class="star">
                <img src="/images/star.svg" alt="" width="100%" height="100%" />
            </div>
            <div>
                <p
                    style="font-size: 1.852vh;
                padding-left: 0.833vh;
                font-weight: 700;
                padding-top: 2.778vh;"
                >
                    Advertise
                </p>

                <p
                    style="font-size: 1.111vh;
                padding-left: 0.8vh;
                paddig-top: 0.741vh"
                >
                    your product / brand
                </p>
            </div>
        </div>
    </div>
</div>

<style>
      .navbar{
        position: fixed;
        width: 100%;
        z-index: 2;
    }
    p {
        margin: 0;
    }
    .main-div {
        font-family: "Orbitron";
        display: flex;
        background-color: #f4eeec;
        width: 177.778vh;
        height: 100vh;
    }
    .left {
        background-color: #d0f9b4;
        width: 75.278vh;
        margin-left: 11.389vh;
    }
    .text1 {
        font-size: 1.852vh;
        font-weight: 400;
        position: absolute;
        top: 13.796vh;
        left: 23.611vh;
        width: 50.648vh;
    }
    .hrcss {
        width: 43.333vh;
        border: 0.093vh solid #000000;
        position: absolute;
        top: 17vh;
        left: 23.611vh;
    }

    .heading {
        font-size: 4.63vh;
        width: 52.87vh;
        top: 19.352vh;
        line-height: 5.301vh;
        left: 23.611vh;
        position: absolute;
        letter-spacing: 0.06em;
        font-weight: 400;
    }

    .text2 {
        width: 48.704vh;
        font-size: 1.296vh;
        line-height: 1.815vh;
        font-weight: 400;
        position: absolute;
        top: 46.296vh;
        left: 23.611vh;
        letter-spacing: 0.06em;
    }
    .btn {
        position: absolute;
        top: 83.426vh;
        left: 23.611vh;
    }

    .right {
        width: 79.907vh;
        position: relative;
        overflow: hidden;
    }
    .img-class {
        width: 82.037vh;
        height: 100vh;
        transition-duration: 2s;
    }
    .circle {
        position: absolute;
        background: #ff007f;
        box-shadow: 0px 0px 2.778vh #ff007f;
        width: 2.778vh;
        height: 2.778vh;
        top: 10.3vh;
        border-radius: 50%;
        left: 14.63vh;
        cursor: pointer;
        opacity: 1;
    }

    .box1 {
        width: 17.963vh;
        height: 9.074vh;
        background-color: white;
        border-radius: 1.111vh;
        display: flex;
        position: absolute;
        top: 21.019vh;
        left: 30.926vh;
        transition-duration: 2s;
        opacity: 0;
    }
    .star {
        width: 1.481vh;
        height: 1.481vh;
        padding-left: 1.481vh;
        padding-top: 2.963vh;
    }
    .text3{
        font-weight: 500;
        font-size: 0.926vh;
        letter-spacing: 0.06em;
        color: #000000;
        position: absolute;
        left: 62.5vh;
        bottom: 1.2vw;
    }
</style>
